import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatCardModule} from "@angular/material/card";
import {StaticvideoComponent} from "./staticvideo.component";
import {FormsModule} from "@angular/forms";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatInputModule} from "@angular/material/input";
import {MatGridListModule} from "@angular/material/grid-list";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatDialogModule} from "@angular/material/dialog";
import {SessionService} from "../../platform/base/services/session.service";
import {StaticvideoService} from "./staticvideo.service";
import {BaseModule} from "../../platform/base/base.module";
import {ImageModule} from "../../platform/image/image.module";
import {VideoDialogComponent} from "./video-dialog/video-dialog.component";
import {VideoCreateDialogComponent} from "./video-create-dialog/video-create-dialog.component";
import {AigPipeModule} from "../base/pipes/aig-pipe.module";
import {BasePipeModule} from "../../platform/base/pipes/base-pipe.module"

// i18n
import {TranslateModule} from "@ngx-translate/core";
//

@NgModule({
	declarations: [StaticvideoComponent, VideoDialogComponent, VideoCreateDialogComponent],
	providers: [
		SessionService,
		StaticvideoService
	],
	imports: [
		CommonModule,
		FormsModule,
		FlexLayoutModule,
		MatCardModule,
		MatIconModule,
		MatButtonModule,
		MatInputModule,
		MatGridListModule,
		MatPaginatorModule,
		BaseModule,
		ImageModule,
		MatDialogModule,
		BasePipeModule,
		AigPipeModule,
		TranslateModule
	],
	exports: [
		StaticvideoComponent,
	],
	bootstrap: [
		VideoDialogComponent,
		VideoCreateDialogComponent
	],

})
export class StaticvideoModule {
}
